


















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { ImageProviderStore } from "@/mixins/imageProviderStore";

@Component
export default class ProfileAvatar extends Mixins(ImageProviderStore) {
  @Prop({ default: "" })
  public email!: string;

  @Prop({ default: null })
  public name!: string;

  @Prop({ default: 100 })
  public size!: string;

  @Prop({ default: true })
  public uploadable!: boolean;

  @Prop({ default: false })
  public isPulsing!: boolean;

  @Prop({ default: false })
  public clickable!: boolean;

  @Prop({ default: false })
  public hasDropdown!: boolean;

  @Prop({ default: "GB" })
  public locationCountryCode!: string;

  public onClick() {
    this.$emit("click");
  }
}
